import React from 'react';
import { Form, Input, Select, DatePicker, Checkbox, Button } from 'antd';
import useSettings from 'hooks/useSettings';
import { EnumFields } from 'types/enumerationData';
import SectionHeader from '../../components/SectionHeader';
import OptLabel from '../../components/OptLabel';
import s from '../../s.module.less';

export default function StepExperience() {
    const [setting] = useSettings();
    const degreeOptions = setting[EnumFields.DEGREE] || [];

    return (
        <>
            <div className={s.wizSection}>
                <SectionHeader title="Healthcare experience" />
                <Form.List name="providerExperienceList" initialValue={[{}]}>
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map((field, idx) => (
                                <div
                                    key={field.key}
                                    className={idx > 0 ? `${s.wizEntry} ${s.entryDivider}` : s.wizEntry}
                                >
                                    <div className={s.entryRow}>
                                        <div className={s.entryTitle}>Experience {idx + 1}</div>
                                        {idx > 0 && (
                                            <button
                                                type="button"
                                                className={s.refRemove}
                                                onClick={() => remove(field.name)}
                                            >
                                                Remove
                                            </button>
                                        )}
                                    </div>
                                    <Form.Item
                                        name={[field.name, 'organizationName']}
                                        label="Organization name"
                                        rules={[{ required: true, message: 'Required' }]}
                                    >
                                        <Input size="large" placeholder="Ex. Hospital or clinic or practice name" />
                                    </Form.Item>
                                    <Form.Item
                                        name={[field.name, 'title']}
                                        label="Title"
                                        rules={[{ required: true, message: 'Required' }]}
                                    >
                                        <Input size="large" placeholder="Ex. Nurse practitioner" />
                                    </Form.Item>
                                    {/* 勾选「在职」时不清空表单里的 endDate：只在展示上隐去（见下方 End date），
                                        取消勾选后原来的离职日期还能还原，不会因为误点丢失 */}
                                    <Form.Item name={[field.name, 'currently']} valuePropName="checked">
                                        <Checkbox>I am currently working in this role</Checkbox>
                                    </Form.Item>
                                    <div className={s.wizRow}>
                                        <Form.Item name={[field.name, 'startDate']} label="Start date">
                                            <DatePicker size="large" style={{ width: '100%' }} />
                                        </Form.Item>
                                        <Form.Item
                                            noStyle
                                            shouldUpdate={(p, c) =>
                                                p.providerExperienceList?.[field.name]?.currently !==
                                                c.providerExperienceList?.[field.name]?.currently
                                            }
                                        >
                                            {({ getFieldValue }) => {
                                                const current = getFieldValue([
                                                    'providerExperienceList',
                                                    field.name,
                                                    'currently',
                                                ]);
                                                // 在职：接口回填的 endDate 与「currently」矛盾，展示上不能带出旧日期。
                                                // 这里渲染一个不绑定表单的占位控件（值仍留在表单里，取消勾选即还原），
                                                // 提交时由 stepValuesToDto 统一把 endDate 置空。
                                                if (current) {
                                                    return (
                                                        <Form.Item label="End date">
                                                            <DatePicker
                                                                size="large"
                                                                style={{ width: '100%' }}
                                                                disabled
                                                                value={null}
                                                                placeholder="Present"
                                                            />
                                                        </Form.Item>
                                                    );
                                                }
                                                return (
                                                    <Form.Item name={[field.name, 'endDate']} label="End date">
                                                        <DatePicker size="large" style={{ width: '100%' }} />
                                                    </Form.Item>
                                                );
                                            }}
                                        </Form.Item>
                                    </div>
                                </div>
                            ))}
                            <Button block onClick={() => add()} className={s.refAdd}>
                                + Add another experience
                            </Button>
                        </>
                    )}
                </Form.List>
            </div>

            <div className={s.wizSection}>
                <SectionHeader title="Education" />
                <Form.List name="providerEducationList" initialValue={[{}]}>
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map((field, idx) => (
                                <div
                                    key={field.key}
                                    className={idx > 0 ? `${s.wizEntry} ${s.entryDivider}` : s.wizEntry}
                                >
                                    <div className={s.entryRow}>
                                        <div className={s.entryTitle}>Education {idx + 1}</div>
                                        {idx > 0 && (
                                            <button
                                                type="button"
                                                className={s.refRemove}
                                                onClick={() => remove(field.name)}
                                            >
                                                Remove
                                            </button>
                                        )}
                                    </div>
                                    <Form.Item
                                        name={[field.name, 'schoolName']}
                                        label="School"
                                        rules={[{ required: true, message: 'Required' }]}
                                    >
                                        <Input size="large" placeholder="Enter the name of your school" />
                                    </Form.Item>
                                    <div className={s.wizRow}>
                                        <Form.Item name={[field.name, 'major']} label={<OptLabel>Major</OptLabel>}>
                                            <Input size="large" placeholder="Enter your field of study" />
                                        </Form.Item>
                                        <Form.Item
                                            name={[field.name, 'degree']}
                                            label="Degree"
                                            rules={[{ required: true, message: 'Required' }]}
                                        >
                                            <Select
                                                size="large"
                                                placeholder="Select your degree"
                                                options={degreeOptions}
                                            />
                                        </Form.Item>
                                    </div>
                                    <Form.Item name={[field.name, 'currently']} valuePropName="checked">
                                        <Checkbox>I am currently pursuing this degree</Checkbox>
                                    </Form.Item>
                                    <div className={s.wizRow}>
                                        <Form.Item
                                            name={[field.name, 'startDate']}
                                            label={<OptLabel>Start date</OptLabel>}
                                        >
                                            <DatePicker size="large" style={{ width: '100%' }} />
                                        </Form.Item>
                                        <Form.Item name={[field.name, 'endDate']} label={<OptLabel>End date</OptLabel>}>
                                            <DatePicker size="large" style={{ width: '100%' }} />
                                        </Form.Item>
                                    </div>
                                </div>
                            ))}
                            <Button block onClick={() => add()} className={s.refAdd}>
                                + Add another education
                            </Button>
                        </>
                    )}
                </Form.List>
            </div>
        </>
    );
}
